import {
    GET_TOOLBOX_LIST,
    GET_NEW_TOOLBOX_UID,
    SET_TOOLBOX,
    SUBMIT_NEW_CATEGORY,
    GET_TOOLBOXTYPE_LIST,
    UPLOAD_FILE,
    SET_FILTER_TOOL_TYPE,
    SET_TOOLBOX_POINTS,
    SET_ROW_COUNT,
    SET_PAGE_INDEX,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_AS,
    SET_SORT_TABLE_KEY,
} from "./types";
import firebase from "firebase/app";

export const setRowCount = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_ROW_COUNT, payload: val });
    };
};
export const setPageIndex = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE_INDEX, payload: val });
    };
};
export const setSortTableType = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_TYPE, payload: val });
    };
};

export const setSortTableAs = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_AS, payload: val });
    };
};

export const setSortTableKey = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_KEY, payload: val });
    };
};
export const editPoints = (point, tid, ref) => {
    return (dispatch) => {
        dispatch({ type: SET_TOOLBOX_POINTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_TOOLBOX_POINTS.FAIL });
                }

                firebase
                    .database()
                    .ref(`/subjects/toolbox/${tid}/points/`)
                    .update({
                        [ref]: point,
                    });
            });
        } catch (e) {
            dispatch({ type: SET_TOOLBOX_POINTS.FAIL });
        }
    };
};

export const getToolBoxList = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOX_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_TOOLBOX_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/toolbox")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_TOOLBOX_LIST.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOOLBOX_LIST.FAIL });
        }
    };
};

export const getNewToolboxID = () => {
    return async (dispatch) => {
        dispatch({ type: GET_NEW_TOOLBOX_UID.REQUEST });
        let toolboxes = await getAllToolboxes();
        let newtoolboxesID = "000001";
        if (toolboxes) {
            let toolboxesIDs = Object.keys(toolboxes).map((e) => e);
            toolboxesIDs = toolboxesIDs.sort().reverse();
            newtoolboxesID = (Number(toolboxesIDs[0]) + 1)
                .toString()
                .padStart(6, "0");
            dispatch({
                type: GET_NEW_TOOLBOX_UID.SUCCESS,
                payload: newtoolboxesID,
            });
        } else if (toolboxes === null) {
            newtoolboxesID = "000001";
            dispatch({
                type: GET_NEW_TOOLBOX_UID.SUCCESS,
                payload: newtoolboxesID,
            });
        } else return dispatch({ type: GET_NEW_TOOLBOX_UID.FAIL });
    };
};

export const getAllToolboxes = async () => {
    let user = await firebase.auth().onAuthStateChanged(async (user) => {
        return user;
    });
    if (user) {
        let active = await firebase
            .database()
            .ref(`/subjects/toolbox/`)
            .once("value");
        active = active.val();

        return active;
    } else {
        return false;
    }
};

export const setToolbox = (
    toolBoxUID = false,
    toolbox = false,
    images = false,
    points = false
) => {
    return (dispatch) => {
        dispatch({ type: SET_TOOLBOX.REQUEST });
        let count_id;

        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                if (toolbox !== false) {
                    firebase
                        .database()
                        .ref(`/subjects/toolbox/`)
                        .once("value")
                        .then(async function (snapshot) {
                            count_id = snapshot.val(); // "last"
                            if (
                                typeof count_id !== "undefined" &&
                                count_id !== null
                            )
                                toolbox["toolbox_id"] = (
                                    "000000" +
                                    (parseInt(
                                        Object.keys(count_id)[
                                            Object.keys(count_id).length - 1
                                        ]
                                    ) +
                                        1)
                                ).slice(-6);
                            else toolbox["toolbox_id"] = "000001";

                            if (images)
                                toolbox["icon_url"] = await uploadIconImage(
                                    toolbox["icon_url"],
                                    toolbox["toolbox_topic"]
                                );
                            firebase
                                .database()
                                .ref(`/subjects/toolbox/`)
                                .child(toolbox.toolbox_id)
                                .update({ profile: toolbox }, (error) => {
                                    if (error) {
                                        dispatch({ type: SET_TOOLBOX.FAIL });
                                    } else
                                        dispatch({ type: SET_TOOLBOX.SUCCESS });
                                })
                                .then(() => {
                                    firebase
                                        .database()
                                        .ref(`/subjects/toolbox/`)
                                        .child(toolbox.toolbox_id)
                                        .update({ points: points }, (error) => {
                                            if (error) {
                                                dispatch({
                                                    type: SET_TOOLBOX.FAIL,
                                                });
                                            } else
                                                dispatch({
                                                    type: SET_TOOLBOX.SUCCESS,
                                                });
                                        });
                                });
                        });
                }
            }
        });
    };
};

export const uploadIconImage = async (imgBlob = "", toolbox_topic = "") => {
    if (imgBlob && toolbox_topic) {
        let imgUploadURL = firebase
            .storage()
            .ref(`/toolboxicon/${toolbox_topic}/iconimg`)
            .put(imgBlob)
            .then(async (snapshot) => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return "";
                }
            })
            .catch(() => {
                return "";
            });
        return imgUploadURL;
    } else {
        return "";
    }
};

export const uploadFile = (toolboxUID, file, callback) => {
    return async (dispatch) => {
        dispatch({ type: UPLOAD_FILE.REQUEST });

        let upload = firebase
            .storage()
            .ref(`toolbox/${toolboxUID}`)
            .child(file.name)
            .put(file);

        upload.on(
            "state_changed",
            (snapshot) => {
                let progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                callback({
                    fileExists: false,
                    inProgress: true,
                    finished: false,
                    error: false,
                    progress: progress,
                    msg: "Upload is " + progress + "% done",
                });
            },
            () => {
                // Handle unsuccessful uploads
                callback({
                    fileExists: false,
                    inProgress: false,
                    finished: false,
                    error: true,
                    msg: "Something went wrong with this upload!",
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            },
            () => {
                //success
                upload.snapshot.ref.getDownloadURL().then((url) => {
                    callback({
                        fileExists: false,
                        inProgress: false,
                        finished: true,
                        error: false,
                        msg: "Success",
                        url,
                    });
                });
            }
        );
    };
};

export const submitNewCategory = (label) => {
    return (dispatch) => {
        dispatch({ type: SUBMIT_NEW_CATEGORY.REQUEST });
        let key = label.toLowerCase().replace(/ /g, "_");
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SUBMIT_NEW_CATEGORY.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/toolbox_types/" + key)
                        .set(label);
                    dispatch({ type: SUBMIT_NEW_CATEGORY.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: SUBMIT_NEW_CATEGORY.FAIL });
        }
    };
};

export const getToolBoxTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOXTYPE_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_TOOLBOXTYPE_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/toolbox_types")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_TOOLBOXTYPE_LIST.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOOLBOXTYPE_LIST.FAIL });
        }
    };
};

export const setFilterToolType = (toolType = "all_categories") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_TOOL_TYPE, payload: toolType });
    };
};
